<template>
    <div class="site-panel w-100" v-if="tzb" style="position: relative">
        <p-site-tzb-history
            :unit     = "site"
            :current  = "tzb"
            :history  = "history.items"
            v-model   = "history.show"
            @selected = "onSelected"
        />

        <p-site-tzb-reports
            v-model   = "reports.show"
            :menu     = "reports.items"
            @selected = "onPrint"
        />

        <div v-if="!readonly && !latest" class="pl-3 pt-2 orange--text text--darken-4 font-weight-medium">
            {{ $t('unit.escalator.tzb.readonly') }}
        </div>

        <v-row class="no-frame">
            <v-col class="main-first-col no-border">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-escalator-general
                        :data     = "tzb"
                        :editable = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-maintenance
                        :data     = "tzb.maintenance"
                        :editable = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-gadget
                        :title      = "$t('unit.escalator.tzb.steps')"
                        :gadget     = "tzb.steps"
                        :editable   = "editable"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="main-middlle-col no-border">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-escalator-gadget
                        :title      = "$t('unit.escalator.tzb.drive')"
                        :type-label = "$t('unit.escalator.tzb.driveType')"
                        :gadget     = "tzb.drive"
                        :editable   = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-gadget
                        :title      = "$t('unit.escalator.tzb.automatic')"
                        :type-label = "$t('unit.escalator.tzb.automaticType')"
                        :gadget     = "tzb.automatic"
                        :editable   = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-gadget
                        :title      = "$t('unit.escalator.tzb.control')"
                        :type-label = "$t('unit.escalator.tzb.controlType')"
                        :gadget     = "tzb.control"
                        :editable   = "editable"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="main-middlle-col no-border">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-escalator-gadget
                        :title    = "$t('unit.escalator.tzb.handrails')"
                        :gadget   = "tzb.handrails"
                        :editable = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-gadget
                        :title    = "$t('unit.escalator.tzb.balustrade')"
                        :gadget   = "tzb.balustrade"
                        :editable = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-gadget
                        :title    = "$t('unit.escalator.tzb.combs')"
                        :gadget   = "tzb.combs"
                        :editable = "editable"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
            <v-col class="main-last-col no-border">
                <v-row class="no-frame mt-2">
                    <c-site-tzb-escalator-gadget
                        :title    = "$t('unit.escalator.tzb.socle')"
                        :gadget   = "tzb.socle"
                        :editable = "editable"
                    />
                </v-row>
                <v-row class="no-frame mt-5">
                    <c-site-tzb-escalator-gadget
                        :title    = "$t('unit.escalator.tzb.socleBrushes')"
                        :gadget   = "tzb.socleBrushes"
                        :editable = "editable"
                    />
                </v-row>
                <c-v-spacer />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import Core                         from "@/modules/core/service/Core";
import Site                         from "@/modules/msd/unit/service/Site";
import Escalator                    from "@/modules/msd/unit/service/Escalator";
import CSiteTzbEscalatorGeneral     from "@/modules/msd/unit/components/dialog/CSiteTzbEscalatorGeneral";
import CSiteTzbEscalatorGadget      from "@/modules/msd/unit/components/dialog/CSiteTzbEscalatorGadget";
import CSiteTzbEscalatorMaintenance from "@/modules/msd/unit/components/dialog/CSiteTzbEscalatorMaintenance";
import CVSpacer                     from "@/modules/core/components/utils/CVSpacer";
import PSiteTzbHistory              from "@/modules/msd/unit/components/dialog/private/PSiteTzbHistory.vue";
import PSiteTzbReports              from "@/modules/msd/unit/components/dialog/private/PSiteTzbReports.vue";

/** Report "Zustandsbericht"; masterdata-svc creates the escalator report (124) for an escalator TZB (HCIT-918). */
const CONDITION_REPORT = 114;

/**
 * TZB of an escalator or moving walk (HCIT-937): the points of the escalator TZB (HCIT-936/979) with history and
 * condition report. Stepchain, plates and lighting are no longer rated and not shown. Only the notes of the latest
 * TZB can be edited; they are saved by id, so a TZB transferred from the app in the meantime is never overwritten.
 */
export default {
    name: "TSiteTzbEscalator",

    components: {
        PSiteTzbReports,
        PSiteTzbHistory,
        CVSpacer,
        CSiteTzbEscalatorMaintenance,
        CSiteTzbEscalatorGadget,
        CSiteTzbEscalatorGeneral
    },

    props: {
        site: {

        },

        readonly: {

        }
    },

    data: () => ({
        history: {
            show : false,
            items: [],
        },

        tzb: null,
        reports: {
            show : false,
            items: [ { id: CONDITION_REPORT, name: "Zustandsbericht" } ],
        },
    }),

    computed: {
        latest () {
            return !!this.tzb && Escalator.isLatest(this.history.items, this.tzb.id);
        },

        editable () {
            return !this.readonly && this.latest;
        }
    },

    mounted() {
        this.load();
    },

    watch: {
        site () {
            this.load();
        }
    },

    methods: {
        /**
         * The current TZB (highest id, the one whose notes can be changed; masterdata-svc creates a missing TZB on
         * read) and the history for the selection. The history is sorted by date, so its first entry is not always
         * the current TZB.
         */
        load () {
            if (!this.site) {
                return Promise.resolve();
            }

            return Promise.all([ Site.condition.history(this.site), Site.condition.loadCurrent(this.site) ])
                .then(([ history, tzb ]) => {
                    this.history.items = history || [];
                    this.tzb = tzb;
                });
        },

        loadTzb (id) {
            Site.condition.load(this.site, id).then(tzb => {
                this.tzb = tzb;
            });
        },

        onSelected (item) {
            this.loadTzb(item.id);
        },

        onReports () {
            this.reports.show = true;
        },

        onPrint (report) {
            Site.condition.report(this, report.id, this.tzb.id, report.name);
        },

        onHistory () {
            this.history.show = true;
        },

        /**
         * Saves the notes of the latest TZB (PUT /api/site/{id}/tzb/{tzbId}); masterdata-svc answers 409 for an older
         * TZB. Emits "saved" so the dialog reloads its current TZB.
         *
         * @return a promise of true if the notes were saved
         */
        onSave () {
            if (!this.editable) {
                return Promise.resolve(true);
            }

            return Site.condition.save(this.site.id, this.tzb.id, this.tzb).then(tzb => {
                if (tzb) {
                    this.tzb = tzb;
                }

                Core.message.alert.save(this);
                this.$emit("saved", this.tzb);
                return true;
            }).catch(() => {
                // e.g. 409: a newer TZB was transferred from the app in the meantime; show the stored state again
                return this.load().then(() => false);
            });
        },
    }
}
</script>

<style scoped>

::v-deep .readonly-value {
    padding-left: 0 !important;
    padding-top: 0 !important;
}

</style>
